module.exports = __webpack_public_path__ + "img/silh_no_neck.d55e3615.png";